import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="infinite-scroll"
export default class extends Controller {
  static values = {
    nextUrl: String
  }

  static targets = ["container"]

  connect() {
    this.container = this.containerTarget || this.element
    this.container.addEventListener("scroll", this.handleScroll.bind(this))
    this.isLoading = false
    this.observer = new MutationObserver(this.handleMutation.bind(this))
    this.observer.observe(this.container, { childList: true, subtree: true })

    // to jest dla przypadku gdy nie ładujemy nic na liście na samym początku
    // bo nie ma wtedy scrolla, więc event się nie wydarzy
    if (this.container.scrollHeight === this.container.clientHeight) {
      this.handleScroll()
    }
  }

  disconnect() {
    this.container.removeEventListener("scroll", this.handleScroll.bind(this))
    this.observer.disconnect()
  }

  handleScroll() {
    if (this.isScrolledToBottom() && !this.isLoading) {
      this.loadMore()
    }
  }

  isScrolledToBottom() {
    const { scrollTop, scrollHeight, clientHeight } = this.container
    return scrollTop + clientHeight >= scrollHeight - 100 // 100px threshold
  }

  loadMore() {
    console.log("loadMore")
    const nextUrl = this.nextUrlValue
    console.log("nextUrl", nextUrl)
    if (nextUrl && !this.isLoading) {
      this.isLoading = true
      fetch(nextUrl, {
        headers: {
          Accept: "text/vnd.turbo-stream.html"
        }
      })
        .then(response => response.text())
        .then(html => {
          if (html.trim() === "") {
            this.nextUrlValue = null
          } else {
            Turbo.renderStreamMessage(html)
          }
        })
    }
  }

  handleMutation(mutations) {
    for (const mutation of mutations) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        this.updateNextUrl()
        this.isLoading = false
        break
      }
    }
  }

  updateNextUrl() {
    const lastFrame = this.element.querySelector("turbo-frame:last-child")
    console.log("lastFrame", lastFrame)
    if (lastFrame) {
      const newNextUrl = lastFrame.getAttribute("data-next-url")
      console.log("newNextUrl", newNextUrl)
      if (newNextUrl) {
        this.nextUrlValue = newNextUrl
        this.element.setAttribute("data-infinite-scroll-next-url-value", newNextUrl)
      } else {
        this.nextUrlValue = null
        this.element.removeAttribute("data-infinite-scroll-next-url-value")
      }
    }
  }
}
